import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import './index.css';
import App from './App';
import { PublicIntakeForm } from './components/PublicIntakeForm';
import AdminLoginPage from './components/adminLoginPage';
import AdminDashboard from './components/AdminDashboard';
import { useNavigate } from 'react-router-dom';
import ResetPasswordPage from './components/ResetPasswordPage';


const AdminLoginWrapper = () => {
  const navigate = useNavigate();

  return (
    <AdminLoginPage
      onLogin={(user) => {
        navigate('/admin-dashboard'); 
      }}
      onCreateAccount={() => {}}
      onBackToHome={() => navigate('/')} 
    />
  );
};


//import reportWebVitals from './reportWebVitals';

// Wrapper component to extract formId from URL params
const PublicIntakeFormWrapper = () => {
  const { formId } = useParams<{ formId: string }>();
  return formId ? <PublicIntakeForm formId={formId} /> : <div>Form ID not found</div>;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Router>
    <Routes>
      <Route path="/intake-form/:formId" element={<PublicIntakeFormWrapper />} />
      <Route path="/admin-login" element={<AdminLoginWrapper />} />
      <Route path="/admin-dashboard" element={<AdminDashboard />} />
      <Route path="/reset-password" element={<ResetPasswordPage onBackToLogin={() => window.location.href = "/"} />} />
      <Route path="*" element={<App />} />
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
